// extracted by mini-css-extract-plugin
module.exports = {"server-info":"server-info_server-info__HmRco"};